/**
 * Abrir uma tela do shell a partir de quem está FORA dele.
 *
 * O `AppShell` e o `useShell()` só existem dentro da PlataformaPessoal. Os
 * modais globais montados no App.jsx (ex.: o de entrada na equipe pelo QR) e o
 * toque numa notificação ficam acima do router e do shell — este evento é a
 * ponte: quem está fora dispara, a PlataformaPessoal ouve e chama
 * `shell.abrir(tela, dados)`.
 *
 * `persistir`: o pedido também fica guardado (sessionStorage) até a plataforma
 * consumir. É o caso do toque na notificação com o app FECHADO: o pedido chega
 * antes de a plataforma montar, e sem a cópia ele se perderia.
 */

export const EVENTO_ABRIR_TELA = 'lesvita:abrir-tela';
const CHAVE_PENDENTE = 'lesvita:tela-pendente';

/**
 * @param {string} tela nome da tela do shell (ex.: 'competicao', 'cl:criar')
 * @param {object} [dados] parâmetros da tela
 * @param {{persistir?: boolean}} [opcoes]
 */
export function abrirTelaGlobal(tela, dados = null, opcoes = {}) {
  if (!tela || typeof window === 'undefined') return;
  if (opcoes.persistir) {
    try {
      sessionStorage.setItem(CHAVE_PENDENTE, JSON.stringify({ tela, dados, em: Date.now() }));
    } catch {
      /* sem storage: vale só o evento */
    }
  }
  window.dispatchEvent(new CustomEvent(EVENTO_ABRIR_TELA, { detail: { tela, dados } }));
}

/** O pedido guardado (até 10 min), consumido de uma vez. */
export function consumirTelaPendente() {
  try {
    const bruto = sessionStorage.getItem(CHAVE_PENDENTE);
    if (!bruto) return null;
    sessionStorage.removeItem(CHAVE_PENDENTE);
    const p = JSON.parse(bruto) || {};
    if (!p.tela || Date.now() - (p.em || 0) > 10 * 60 * 1000) return null;
    return { tela: p.tela, dados: p.dados || null };
  } catch {
    return null;
  }
}
